import { useField } from 'formik'
import { Ref, useCallback } from 'react'
import { Radio } from '../../Radio'
import type {
  RadioChangeEvent,
  RadioGroupProps as AntdRadioGroupProps
} from '../../Radio'
import type { FormikFieldProps } from '../typings/FieldProps'

export type RadioGroupProps = FormikFieldProps &
  AntdRadioGroupProps & {
    ref?: Ref<HTMLDivElement>
  }

export const RadioGroup = ({
  name,
  onChange: onChangeProp,
  ...restProps
}: RadioGroupProps) => {
  const [field, , helpers] = useField(name)
  const { value } = field
  const { setValue, setTouched } = helpers

  const handleChange = useCallback(
    (event: RadioChangeEvent) => {
      setValue(event.target.value)
      // we don't have "onBlur" event, so we need to mark this input as touched, but in next "tick" to prevent showing error
      setTimeout(() => setTouched(true), 0)
      onChangeProp?.(event)
    },
    [onChangeProp, setTouched, setValue]
  )

  return (
    <Radio.Group
      name={name}
      value={value}
      onChange={handleChange}
      {...restProps}
    />
  )
}
